import { baseName } from './util';
import type { ApplyBannerProps } from './types';

export const ApplyBanner = ({ outcome, onDismiss }: ApplyBannerProps) => {
  const isSuccess = outcome.tone === 'success';
  return (
    <div className={`syntax-apply-banner syntax-apply-${outcome.tone}`}>
      <div className="syntax-apply-main">
        <span className="syntax-apply-icon">{isSuccess ? '✓' : '⚠'}</span>
        <div className="syntax-apply-text">
          <div className="syntax-apply-message">
            {isSuccess && <strong>Everything applied — </strong>}
            {outcome.message}
          </div>
          {outcome.skipped.map((plan) => (
            <div key={`${plan.file}:${plan.page}`} className="syntax-apply-detail">
              {baseName(plan.file)} &middot; p.{plan.page} — {plan.reason}
            </div>
          ))}
          {outcome.errors.map((error, index) => (
            <div key={index} className="syntax-apply-detail">{error}</div>
          ))}
        </div>
      </div>
      <button className="syntax-apply-dismiss" onClick={onDismiss} title="Dismiss">
        &times;
      </button>
    </div>
  );
};
